module.exports = __webpack_public_path__ + "img/Beginner-4.fac97478.gif";